import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { resolveApiAssetUrl } from '../lib/api';
import { SECTIONS, sectionHook } from '../lib/domHooks';
import {
  fetchSponsorships, sponsorshipTierLabel, sponsorshipTypeLabel,
} from '../lib/sponsorships';

/**
 * Footer'ın en altındaki resmi sponsorluk bandı.
 *
 * Beş kabuk da (klasik, Merit, Zümrüt, Paris, Herkül) **bu bileşeni** çizer:
 * geometri ve renk tema değişkenlerinden (`--pusu-*`) türediği için şema
 * başına çatallanmaz. Şemaya özel bir ayrım gerekirse `className` ile ek bir
 * sınıf verilir, bileşen kopyalanmaz.
 *
 * Kayıt yoksa hiçbir şey çizilmez — boş bir "SPONSORLUKLARIMIZ" başlığı
 * footer'ı uzatmaktan başka bir şey yapmaz.
 */
const SponsorshipStrip = ({ className = '', title = 'RESMİ SPONSORLUKLARIMIZ' }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    fetchSponsorships().then((list) => {
      if (alive) setItems(list);
    });
    return () => { alive = false; };
  }, []);

  if (!items.length) return null;

  return (
    <div className={`sponsorship-strip ${className}`.trim()} {...sectionHook(SECTIONS.SPONSORS)}>
      <div className="sponsorship-strip-inner">
        <div className="sponsorship-strip-head">
          <h2 className="sponsorship-strip-title">{title}</h2>
          <Link to="/sponsorluk" className="sponsorship-strip-more">
            Tümünü gör
          </Link>
        </div>
        <div className="sponsorship-strip-list">
          {items.map((item) => {
            const accent = item.accent_color || 'var(--pusu-accent)';
            const meta = [sponsorshipTypeLabel(item), item.season]
              .filter(Boolean).join(' · ');
            const body = (
              <>
                {item.logo_url && (
                  <span className="sponsorship-card-logo">
                    <img
                      src={resolveApiAssetUrl(item.logo_url)}
                      alt={item.name}
                      loading="lazy"
                    />
                  </span>
                )}
                <span className="sponsorship-card-text">
                  <span className="sponsorship-card-tier" style={{ color: accent }}>
                    {sponsorshipTierLabel(item)}
                  </span>
                  <span className="sponsorship-card-name">{item.name}</span>
                  {meta && <span className="sponsorship-card-meta">{meta}</span>}
                </span>
                {item.link && (
                  <ExternalLink size={14} className="sponsorship-card-out" aria-hidden="true" />
                )}
              </>
            );
            const style = { '--sponsorship-accent': accent };
            return item.link ? (
              <a
                key={item.id}
                className="sponsorship-card"
                style={style}
                href={item.link}
                target="_blank"
                rel="noreferrer"
                aria-label={`${item.name} — ${sponsorshipTierLabel(item)}`}
              >
                {body}
              </a>
            ) : (
              <span key={item.id} className="sponsorship-card" style={style}>
                {body}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SponsorshipStrip;
